import React, { Component } from 'react';

class ErrorMessageLabel extends Component {
    render() {
        return (
            <div style={{ display: this.props.boolean?'block':'none', color: '#9f3a38' }}>
                {this.props.message}
            </div>
        );
    }
}

export default ErrorMessageLabel;
